import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { CircularProgress } from "@mui/material";

import { LoadingInputContainer } from "./styled";

const LoadingInput: FC = () => {
    const { t } = useTranslation();
    return (
        <LoadingInputContainer>
            <CircularProgress
                className="loading-in-progress"
                aria-busy
                size={20}
                thickness={3}
                style={{ color: "var(--color-grey-700)" }}
            />
            <span className="sr-only">{t("Common.Loading")}</span>
        </LoadingInputContainer>
    );
};

export default LoadingInput;
